import { render, staticRenderFns } from "./IconResetConvButton.vue?vue&type=template&id=2d4407aa&scoped=true&lang=pug&"
import script from "./IconResetConvButton.vue?vue&type=script&lang=ts&"
export * from "./IconResetConvButton.vue?vue&type=script&lang=ts&"
import style0 from "./IconResetConvButton.vue?vue&type=style&index=0&id=2d4407aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4407aa",
  null
  
)

export default component.exports